import React from "react";

const Biographies = props => {
  return (
    <div className="provider-biography-container">
      {props.currentProvider.map((provider, index) => (
        <div key={index}>
          {/* First section: Image floating left with provider name and status */}
          <div className="position-relative mb-4">
            {/* Provider image with float-start to make text wrap around it */}
            <div className="float-md-start me-md-4 mb-3 mb-md-0 text-center mx-auto mx-md-0" style={{
              maxWidth: '220px'
            }}>
              <div style={{
                width: '220px',
                height: '280px',
                display: 'inline-block',
                backgroundImage: `url(${provider.PictureLink})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center top',
                borderRadius: '10px',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.25)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}></div>
            </div>

            {/* Provider header info */}
            <div>
              <h2 style={{ 
                fontWeight: '600', 
                fontSize: '42px', 
                color: '#2D4F91', 
                lineHeight: '1.1',
                marginBottom: '10px' 
              }}
              className="text-center text-md-start">
                {provider.DisplayName}
              </h2>
              
              {provider.CurrentlyAcceptingPatients ?
                <div style={{ 
                  fontWeight: '500', 
                  fontSize: '18px', 
                  color: '#2CA744', 
                  marginBottom: '18px',
                  paddingLeft: '3px'
                }}
                className="text-center text-md-start">
                  Currently Accepting New Patients
                </div>
                :
                <div style={{ 
                  fontWeight: '500', 
                  fontSize: '18px', 
                  color: '#D32F2F', 
                  marginBottom: '18px',
                  paddingLeft: '3px'
                }}
                className="text-center text-md-start">
                  Not Accepting New Patients at this time
                </div>
              }
            
              {/* Provider bio text that will wrap around the image */}
              <div className="provider-bio text-md-start text-center" style={{ fontSize: '16px', lineHeight: '1.6', color: '#444' }}>
                <p>{provider.Bio1}</p>
                <p>{provider.Bio2}</p>
                <p>{provider.Bio3}</p>
              </div>
            </div>

            {/* Clearfix to prevent floating issues */}
            <div className="clearfix"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Biographies;